import from from './from'; // lol
import of from './of';

export default {
    of,
    from
};
